import { posthog } from '../lib/analytics'

export const trackEvent = (eventName: string, properties: Record<string, any> = {}) => {
  posthog.capture(eventName, {
    ...properties,
    timestamp: new Date().toISOString(),
    page_url: window.location.pathname,
  })
}

export const useTracking = () => {
  const track = (eventName: string, properties: Record<string, any> = {}) => {
    trackEvent(eventName, properties)
  }

  const trackClick = (elementName: string, properties: Record<string, any> = {}) => {
    track('element_clicked', { element: elementName, ...properties })
  }

  const trackView = (sectionName: string, properties: Record<string, any> = {}) => {
    track('section_viewed', { section: sectionName, ...properties })
  }

  const trackFeatureUsed = (featureName: string, action: string, properties: Record<string, any> = {}) => {
    track('feature_used', { feature: featureName, action, ...properties })
  }

  return { track, trackClick, trackView, trackFeatureUsed }
}
